import R from 'app/assets/R'
import {
  ExportOutlined,
  LoadingOutlined,
  SyncOutlined,
} from '@ant-design/icons'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { useTranslation } from 'react-i18next'
import { ButtonAction } from 'app/components/header/components/HeaderPage/styles'
import { useState } from 'react'

const ExportAndSync: React.FC<{
  onPressExport: () => void
  onPressSync: () => void
}> = ({ onPressExport, onPressSync }) => {
  const { t } = useTranslation()
  const [exportLoading, setExportLoading] = useState(false)
  const [syncLoading, setSyncLoading] = useState(false)

  const handleExport = async () => {
    setExportLoading(true)
    await onPressExport()
    setExportLoading(false)
  }

  const handleSync = async () => {
    setSyncLoading(true)
    await onPressSync()
    setSyncLoading(false)
  }

  return (
    <>
      <BaseCol>
        <ButtonAction onClick={handleSync} disabled={syncLoading}>
          <BaseRow gutter={8}>
            <BaseCol>
              <SyncOutlined rev={undefined} />
            </BaseCol>
            <BaseCol>{t(R.strings.sync)}</BaseCol>
            <BaseCol>
              {syncLoading && <LoadingOutlined rev={undefined} />}
            </BaseCol>
          </BaseRow>
        </ButtonAction>
      </BaseCol>
      <BaseCol>
        <ButtonAction onClick={handleExport}>
          <BaseRow gutter={8}>
            <BaseCol>
              <ExportOutlined rev={undefined} />
            </BaseCol>
            <BaseCol>{t(R.strings.export_excel)}</BaseCol>
            <BaseCol>
              {exportLoading && <LoadingOutlined rev={undefined} />}
            </BaseCol>
          </BaseRow>
        </ButtonAction>
      </BaseCol>
    </>
  )
}

export default ExportAndSync
